import { Logger } from "@prop-cafe/observability-ts/logger";
export type { LoggerOptions } from "@prop-cafe/observability-ts/logger";

export { Logger };
export const logger = new Logger({ serviceName: "prop-cafe-pm-ui" });
